var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  ja:"),_c('input',{attrs:{"type":"radio","name":"gender","value":"ja"}}),_vm._v("    \n  nee:"),_c('input',{attrs:{"type":"radio","name":"gender","value":"nee"}})])
}]

export { render, staticRenderFns }